module.exports = __webpack_public_path__ + "static/media/banner1.de26f06a.jpg";